import React from "react";
import { GRID_PX } from "../../constants";

/**
 * CAD Canvas Grid — blueprint-style dot/line grid.
 * Minor grid: 1 unit (WORLD_SNAP = 100mm), Major grid: 5 units (500mm)
 * Background: deep dark blue — classic CAD/blueprint look.
 */
export default function CanvasGrid({ w, h, pan, zoom }) {
  const g  = GRID_PX * zoom;
  const g5 = g * 5;
  const g10 = g * 10;
  const ox  = pan.x % g,    oy  = pan.y % g;
  const ox5 = pan.x % g5,   oy5 = pan.y % g5;
  const ox10= pan.x % g10,  oy10= pan.y % g10;

  return (
    <g>
      <defs>
        {/* Minor grid — very faint dots at each snap point */}
        <pattern id="cg1" width={g} height={g}
          patternUnits="userSpaceOnUse"
          patternTransform={`translate(${ox},${oy})`}>
          <circle cx={0} cy={0} r={0.4} fill="#0c1a2a" opacity={0.8}/>
        </pattern>
        {/* Major grid — slightly brighter lines every 5 units */}
        <pattern id="cg5" width={g5} height={g5}
          patternUnits="userSpaceOnUse"
          patternTransform={`translate(${ox5},${oy5})`}>
          <path d={`M${g5} 0L0 0 0 ${g5}`}
            fill="none" stroke="#0a1828" strokeWidth={0.6} opacity={0.9}/>
        </pattern>
        {/* Major-major grid — solid lines every 10 units */}
        <pattern id="cg10" width={g10} height={g10}
          patternUnits="userSpaceOnUse"
          patternTransform={`translate(${ox10},${oy10})`}>
          <path d={`M${g10} 0L0 0 0 ${g10}`}
            fill="none" stroke="#0f2040" strokeWidth={0.8}/>
        </pattern>
      </defs>

      {/* Background */}
      <rect width={w} height={h} fill="#020a14"/>
      {/* Grid layers */}
      <rect width={w} height={h} fill="url(#cg1)"/>
      <rect width={w} height={h} fill="url(#cg5)"/>
      <rect width={w} height={h} fill="url(#cg10)"/>
    </g>
  );
}
